/**
 * Centred modal dialog. Wraps the .modal-* CSS already in App.css.
 * Pass footer for action buttons; onClose fires on backdrop click and the ✕ button.
 */
export default function Modal({ title, onClose, children, footer, width, busy = false }) {
  function backdropClose() {
    if (!busy) onClose?.();
  }
  return (
    <div className="modal-overlay" onClick={backdropClose}>
      <div className="modal" style={width ? { width } : undefined} onClick={(e) => e.stopPropagation()}>
        <div className="modal-hdr">
          <span>{title}</span>
          <button type="button" className="modal-close" onClick={backdropClose}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
        {footer != null && <div className="modal-ftr">{footer}</div>}
      </div>
    </div>
  );
}
